import {
  Html5Qrcode,
  Html5QrcodeScanType,
  Html5QrcodeScannerState,
  Html5QrcodeSupportedFormats,
} from "html5-qrcode"
import { useEffect } from "react"
import "./html5-qrcode.css"

const qrcodeRegionId = "reader"

// Creates the configuration object for Html5QrcodeScanner.
const createConfig = (props) => {
  let config = {
    fps: 15,
    qrbox: {
      width: 400,
      height: 300,
    },
    aspectRatio: undefined,
    disableFlip: undefined,
    // focusMode: "continuous",
    defaultZoomValueIfSupported: 1.7,
    showZoomSliderIfSupported: true,
    rememberLastUsedCamera: true,
    experimentalFeatures: {
      useBarCodeDetectorIfSupported: true,
    },
    // willReadFrequently: true,
    supportedScanTypes: [
      // Html5QrcodeScanType.SCAN_TYPE_FILE,
      Html5QrcodeScanType.SCAN_TYPE_CAMERA,
    ],
    formatsToSupport: [Html5QrcodeSupportedFormats.EAN_13],
    // videoConstraints: { facingMode: { exact: "environment" }, deviceId: cameraId },
  }
  if (props.fps) {
    config.fps = props.fps
  }
  if (props.qrbox) {
    config.qrbox = props.qrbox
  }
  if (props.aspectRatio) {
    config.aspectRatio = props.aspectRatio
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip
  }
  return config
}

// const Html5QrcodePlugin = (props) => {
//   let cameraId = null
//   useEffect(() => {
//     // when component mounts

//     const verbose = props.verbose === true
//     // Suceess callback is required.
//     if (!props.qrCodeSuccessCallback) {
//       throw "qrCodeSuccessCallback is required callback."
//     }

//     let html5QrcodeScanner = null
//     // const html5QrCode = new Html5Qrcode("reader");
//     Html5Qrcode.getCameras().then((devices) => {
//       if (devices && devices.length) {
//         if (devices.length === 1) {
//           cameraId = devices[0].id
//         } else {
//           //check first for 2_0 camera as this is usally the default back one
//           for (const device of devices) {
//             const cameraLabel = device.label
//             if (
//               cameraLabel &&
//               (cameraLabel.toLowerCase().includes("2 0") ||
//                 cameraLabel.toLowerCase().includes("2.0") ||
//                 (cameraLabel.toLowerCase().includes("back") &&
//                   (cameraLabel.toLowerCase().includes("2 2") ||
//                     cameraLabel.toLowerCase().includes("2.2"))))
//             ) {
//               cameraId = device.id
//             }
//           }
//           //if none is found take the first back one
//           if (cameraId == null) {
//             for (const device of devices) {
//               const cameraLabel = device.label
//               if (cameraLabel && cameraLabel.toLowerCase().includes("back")) {
//                 cameraId = device.id
//               }
//             }
//           }
//         }
//       }
//     })

//     //   // html5QrCode.start(cameraId, config, props.qrCodeSuccessCallback, props.qrCodeErrorCallback)
//     // })

//     const config = createConfig(props, cameraId)
//     html5QrcodeScanner = new Html5QrcodeScanner(qrcodeRegionId, config, verbose)

//     html5QrcodeScanner.render(
//       props.qrCodeSuccessCallback,
//       props.qrCodeErrorCallback
//     )

//     setTimeout(function () {
//       html5QrcodeScanner.applyVideoConstraints({
//         focusMode: "continuous",
//         deviceId: cameraId,
//         // autoGainControl: true,
//         advanced: [{ zoom: 1.5 }],
//         facingMode: { exact: "environment" },
//       })
//     }, 2000)

//     // cleanup function when component will unmount
//     return () => {
//       html5QrcodeScanner.clear().catch((error) => {
//         console.error("Failed to clear html5QrcodeScanner. ", error)
//       })
//     }
//   }, [])

//   return <div id={qrcodeRegionId} />
// }

const Html5QrcodePlugin = (props) => {
  useEffect(() => {
    if (!props.qrCodeSuccessCallback) {
      throw new Error("qrCodeSuccessCallback is required callback.")
    }

    const config = createConfig(props)

    const html5QrCode = new Html5Qrcode(qrcodeRegionId)
    Html5Qrcode.getCameras().then((devices) => {
      if (devices && devices.length) {
        let cameraId = devices[0].id // Default to the first camera if specific criteria are not met
        // Implement your logic to choose a cameraId based on your criteria
        // For example, choosing the first back camera
        if (devices.length === 1) {
          cameraId = devices[0].id
        } else {
          //check first for 2_0 camera as this is usally the default back one
          for (const device of devices) {
            const cameraLabel = device.label
            if (
              cameraLabel && cameraLabel.toLowerCase().includes("back") &&
              (cameraLabel.toLowerCase().includes("2 0") ||
                cameraLabel.toLowerCase().includes("2.0") //||
                // cameraLabel.toLowerCase().includes("2 2") ||
                // cameraLabel.toLowerCase().includes("2.2")
                )
            ) {
              cameraId = device.id
            }
          }
          //if none is found take the first back one
          if (cameraId == null) {
            for (const device of devices) {
              const cameraLabel = device.label
              if (cameraLabel && cameraLabel.toLowerCase().includes("back")) {
                cameraId = device.id
              }
            }
          }
        }

        html5QrCode
          .start(
            cameraId,
            config,
            props.qrCodeSuccessCallback,
            props.qrCodeErrorCallback
          )
          .catch((err) => {
            console.error(`Unable to start camera with ID ${cameraId}`, err)
          })

        let videoConfig = {
          focusMode: "continuous",
          // autoGainControl: true,
          advanced: [{ zoom: 1.7 }],
          // facingMode: { exact: "environment" },
        }
        startTimer(html5QrCode, videoConfig)
      }
    })

    return () => {
      if (html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
        html5QrCode.stop().catch((error) => {
          console.error("Failed to stop html5QrCode. ", error)
        })
      }
    }
  }, [props])

  return <div id={qrcodeRegionId} style={{ width: 300, height: 400 }} />
}

const startTimer = (html5QrCode, videoConfig) => {
  setTimeout(function () {
    if (html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
      html5QrCode.applyVideoConstraints(videoConfig)
    } else {
      startTimer(html5QrCode, videoConfig)
    }
  }, 2000)
}

export default Html5QrcodePlugin
